import { Injectable } from '@angular/core';
import Task from '../../../types/task/Task';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class TaskService {

    private RESOURCE: string = 'task';

    constructor(private baseService: BaseService) {
    }

    /**
     * Get all tasks.
     *
     * @return The tasks.
     */
    public async getTasks(): Promise<Task[]> {
        return await this.baseService.get<Task[]>(this.RESOURCE);
    }
}
